import type { AxiosError } from 'axios';
import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';

import type { IError } from '@/api/http';
import { useApiClient } from '@/providers/ApiClientProvider';
import API from '@/lib/API';

type UserLogoutArgs = {
  access_token: string;
};

export const useUserLogoutMutation = (
  options?: UseMutationOptions<unknown, AxiosError<IError>, UserLogoutArgs>,
) => {
  const { httpWithAuth, api } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UserLogoutArgs): Promise<void> => {
      if (payload.access_token === 'dummy-access-token') return;
      return await api<void>(httpWithAuth.post(API.V1.logout, payload));
    },
    ...options,
    onSuccess(
      response: unknown,
      variables: UserLogoutArgs,
      context: unknown,
      mutation: unknown,
    ): void {
      queryClient.invalidateQueries({ queryKey: ['logout'] });
      options?.onSuccess?.(response as void, variables, context, mutation as never);
    },
  });
};
